var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.875 9.80005V14.6109C38.875 16.2036 40.166 17.4974 41.7615 17.4974H46.5723",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1855 41.8857C25.8012 41.8857 30.3535 37.3334 30.3535 31.7178C30.3535 26.1022 25.8012 21.5498 20.1855 21.5498C14.5699 21.5498 10.0176 26.1022 10.0176 31.7178C10.0176 37.3334 14.5699 41.8857 20.1855 41.8857Z",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.866 45.7669V50.1999C13.866 52.3254 15.5892 54.0486 17.7147 54.0486H46.5715C48.6969 54.0486 50.4201 52.3254 50.4201 50.1999V17.1656C50.4201 16.1463 50.0152 15.1651 49.2922 14.4449L41.9264 7.07913C41.2035 6.35615 40.225 5.95117 39.2057 5.95117H17.7119C15.5865 5.95117 13.8633 7.67437 13.8633 9.79983V17.9973",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7119 31.7177C14.7119 28.6953 17.1635 26.2437 20.1859 26.2437",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 40.293L33.4823 48.1425C35.211 48.1425 36.6107 46.7427 36.6107 45.0141L28.7612 37.1646",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/DocumentSearch.0421c0798dd17853460aa8ce8b5ae0ac.svg";
export { ForwardRef as ReactComponent };